@if (libConfig.showBefragungBanner) {
  <now-befragung-banner></now-befragung-banner>
}
